<template>
<div class="chapter">
<div class="inner_page">
<p class="p4"><span class="sz"><b></b> </span></p>
<p class="p5"><span class="sz"><b>A Note on the Manuscript</b></span></p>
<p class="p4"><span class="sz"><b></b> </span></p>
<p class="p3"><span class="sz">My friend, Harrison Smith, a young lawyer of the city, has recently given me a second manuscript, purportedly by the individual Tarl Cabot. It was his desire that I bring this second document, as I did the first, to the attention of a publisher. This time, however, because of the numerous claims and inquiries generated by the first manuscript, <i>Tarnsman of Gor</i>, pertaining to various matters ranging from further alleged documentation for the existence of the Counter-Earth to disputes concerning the authorship of the manuscript, I have prevailed upon Smith to write something in the way of a preface to this second account, making clear his own role in these matters and telling us a bit more about Tarl Cabot, whom I have never had the good fortune to meet in person.</span></p>
<p class="p6"><span class="sz">John Norman</span></p>
<p class="p4"><span class="sz"><b></b> </span></p>
<p class="p7"><span class="sz"> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section2.vue?7fba9b1a